<!-- 登录框组件 -->
<template>
	<div class="loginitem">
		<div class="bagdiv">
			<img class="bag" src="../../assets/images/loginboxbag.png" />
			<div class="inputdiv">
				<span class="userinput"><label>学&ensp;&ensp;号</label><input v-model.lazy="userno" type="number"
						placeholder="请输入您的学号" /></span>
				<span class="userinput password"><label>密&ensp;&ensp;码</label><img
						src="../../assets/images/yj.png" @click="showpassword" /><input ref="password" v-model.lazy="password" type="password"
						placeholder="请输入密码" /></span>
				<div class="yzmbox"><span class="userinput yzmdiv"><label>验证码</label><input type="text"
							placeholder="请输入验证码" v-model.lazy="codestr" /></span><img @click="getCode()"
						:src="codeImg" /></div>

				<div class="alink"><a href="javascript:void(0);" @click="inRegister" class="zc">注册</a><a
						href="javascript:void(0);" @click="inResetPassword" class="mm">忘记密码</a></div>
				<div class="btndiv">
					<a href="javascript:void(0);"><span class="login" @click="loginSubmit">登录</span></a>
					<a href="javascript:void(0);"><span class="allin">专家通道</span></a>
				</div>
			</div>
		</div>
		<popup ref="popup" :types="popuptype" :message="loginmessage"></popup>
		<popuptos ref="popuptos" :text="loginmessage"></popuptos>
	</div>
</template>

<script>
	import axios from 'axios'
	import popup from '../popups/popup.vue'
	import popuptos from '../popups/popuptos.vue'
	export default {
		name: 'Loginitem',
		data() {
			return {
				userno: null,
				password: null,
				codestr: null,
				codeImg: null,
				loginmessage: null,
				popuptype:'success',
				isshow: false
			}
		},
		components:{
			popup,
			popuptos
		},
		created() {
			this.getCode()
		},
		methods: {
			showpassword(){
				if(!this.isshow){
					this.$refs.password.type = "text"
					this.isshow = true
				}else{
					this.$refs.password.type = "password"
					this.isshow = false
				}
			},
			inRegister() {
				this.$router.push('/register')
			},
			inResetPassword() {
				this.$router.push({
					name: 'ResetPassword',
					params: {
						type: 1
					}
				})
			},
			getCode() { //获取验证码
				axios({
					method: 'get',
					url: this.$api.commonUrl + 'captcha',
					responseType: "arraybuffer"
				}).then(res => {
					if (res.status == 200) {
						this.codeImg = this.setImg(res.data)
					} else {
						console.log(res.data.message)
					}
				}).catch(err => {
					console.log("code", err)
				})
			},
			loginSubmit() { //登录
				if (this.checkLogin()) {
					axios({
						method: 'post',
						url: this.$api.commonUrl + 'student/login',
						data: {
							identifier: this.userno,
							credential: this.password,
							code: this.codestr
						},
						responseType: "json"
					}).then(res => {
						if (res.data.code == '200') {
							this.popuptype = 'success'
							this.$store.commit('setVuex', res.data.data)
							this.$router.replace('/home')
						} else if(res.data.message=='审核未通过'){
							this.loginmessage = "注册信息审核中，请耐心等待或联系管理员！"
							this.$refs.popuptos.popuptosshow()
						}else {
							this.getCode()
							this.popuptype = 'error'
							this.loginmessage = res.data.message
							this.$refs.popup.popupshow()
						}
					}).catch(err => {
						console.log("login", err)
					})
				} else {
					this.$refs.popup.popupshow()
				}
			},
			setImg(imgfile) { //处理图片
				let imgstr = "data:image/png;base64," +
					btoa(
						new Uint8Array(imgfile).reduce(
							(data, byte) => data + String.fromCharCode(byte), ""
						)
					)
				return imgstr
			},
			checkLogin() {
				if (this.userno == null || this.userno == '') {
					this.loginmessage = "请输入学号"
					this.popuptype = 'warning'
					return false
				} else if (this.password == null || this.password == '') {
					this.loginmessage = "请输入密码"
					this.popuptype = 'warning'
					return false
				} else if (this.codestr == null || this.codestr == '') {
					this.loginmessage = "请输入验证码"
					this.popuptype = 'warning'
					return false
				} else {
					this.loginmessage = null
					return true
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/style.css");

	.loginitem {
		position: absolute;
		z-index: 3;
		width: 100%;
		height: 100%;
	}

	.loginitem .bagdiv {
		position: absolute;
		width: 75rem;
		height: 37.5rem;
		margin: auto;
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
	}

	.loginitem .bagdiv .bag {
		width: 100%;
		height: auto;
		display: block;
		position: absolute;
	}

	.loginitem .inputdiv {
		width: 22rem;
		height: 27rem;
		margin-top: 11.5rem;
		position: relative;
		z-index: 3;
		float: right;
		margin-right: 12.2rem;
		text-align: center;
	}

	.loginitem .inputdiv input {
		outline-style: none;
		border: 1px solid #d3bbb6;
		border-radius: 0px;
		height: 2rem;
		line-height: 2rem;
		font-size: 1rem;
		margin: 0.2rem;
		padding: 0.2rem 0.4rem;
		width: 20rem;
	}

	.loginitem .userinput {
		display: inline-block;
		border: 2px solid #823d32;
		position: relative;
		margin-top: 1rem;
	}

	.loginitem .userinput label {
		position: absolute;
		background: #FFFFFF;
		font-size: 0.9rem;
		line-height: 1rem;
		top: -0.5rem;
		left: 1rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		color: #823d32;
		font-weight: bold;
	}
	.loginitem .userinput p {
		position: absolute;
		background: #FFFFFF;
		font-size: 0.9rem;
		line-height: 1rem;
		top: -0.5rem;
		right: 1rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		color: #f91414;
		font-weight: bold;
		display: none;
	}

	.loginitem .password img {
		width: 2rem;
		height: 2rem;
		position: absolute;
		right: 4px;
		margin: auto;
		top: 0px;
		bottom: 0px;
		display: block;
	}

	.loginitem .yzmdiv input {
		width: 11rem;
	}

	.loginitem .yzmbox {
		display: inline-block;
	}

	.loginitem .yzmbox img {
		width: 7rem;
		height: auto;
		float: right;
		display: block;
		margin-top: 1.1rem;
		margin-left: 2rem;
	}

	.loginitem .alink {
		width: 21rem;
		height: 2rem;
		margin-top: 1rem;
		font-size: 0.9rem;
		line-height: 2rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}

	.loginitem .zc {
		float: left;
		color: #3e392e;
	}

	.loginitem .mm {
		float: right;
		color: #3e392e;
	}

	.loginitem .btndiv {
		width: 21rem;
		height: 3rem;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		margin-top: 1rem;
		font-size: 1rem;
		line-height: 3rem;
	}

	.loginitem .btndiv .login {
		background: #a73a29;
		color: #FFFFFF;
		display: block;
		width: 13rem;
		height: 3rem;
		float: left;
	}

	.loginitem .btndiv .allin {
		background: #967149;
		color: #FFFFFF;
		display: block;
		width: 7rem;
		height: 3rem;
		float: right;
	}
	/* 
	@media screen and (max-width: 1680px) {
		html {
			font-size: 14px;
		}
	}
	
	@media screen and (max-width: 1600px) {
		html {
			font-size: 13px;
		}
	}
	
	@media screen and (max-width: 1440px) {
		html {
			font-size: 12px;
		}
	}
	
	@media screen and (max-width: 1400px) {
		html {
			font-size: 12px;
		}
	}
	
	@media screen and (max-width: 1366px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1360px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1280px) {
		html {
			font-size: 11px;
		}
	}
	
	@media screen and (max-width: 1152px) {
		html {
			font-size: 10px;
		}
	}
	
	@media screen and (max-width: 1024px) {
		html {
			font-size: 9px;
		}
	}
	
	@media screen and (max-width: 800px) {
		html {
			font-size: 8px;
		}
	} */
</style>
